import type { SxProps, Theme } from '@mui/material/styles';

export const footerRootSx: SxProps<Theme> = {
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: 0,
  width: 'min(100%, 1000px)',
};
